import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Cover from "./Cover";
import { Box, Button, Container, Typography } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { FETCH_TEAM_ASSOCIATES_LOADING } from "../../../../containers/actions/types";
import { fetchTeamAssociates } from "../../../../containers/actions/common/teamMemberAction";

const useStyles = makeStyles((theme) => ({
  heading: {
    marginTop: "2em",
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "1em",
  },
  subtitle: {
    marginTop: "10px",
    fontSize: "14px",
    fontWeight: 500,
  },
  values: {
    fontSize: "14px",
    fontWeight: 400,
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginTop: "auto",
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
}));
export default function PermissionChangesSaved({
  setChangesSavedDrawer,
  count,
  user,
  setViewDetailsDrawer,
  handleRefresh,
  selectedRole
}) {
  const dispatch = useDispatch();
  const classes = useStyles();
 
  const handleOk = () => {
    setChangesSavedDrawer(false);
    setViewDetailsDrawer(false);
    handleRefresh();
    if (selectedRole) {
        dispatch({
          type: FETCH_TEAM_ASSOCIATES_LOADING,
          payload: true,
        });
        dispatch(
          fetchTeamAssociates({
            departmentID: selectedRole.departmentID,
            collaborator_role_id: selectedRole.collaborator_role_id,
            searchString: "all",
            status: "Active",
          })
        );
      }
  };
  return (
    <Box
      style={{ minHeight: "100%", display: "flex", flexDirection: "column" }}
    >
      <Cover
        profilePic={user?.profile_pic}
        handleRefresh={handleRefresh}
        user={user}
        setViewDetailsDrawer={setViewDetailsDrawer}
      />
      <Container
        style={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        <Typography
          className={classes.heading}
          style={{ display: "flex", fontWeight: 600 }}
          gutterBottom
        >
          Permission changes saved
          <CheckCircleIcon style={{ color: "green", marginLeft: "10px" }} />
        </Typography>
        <Typography className={classes.subtitle}>Newly enabled</Typography>
        <Typography className={classes.values}>
          {count.enabled} {count.enabled === 1 ? "permission" : "permissions"}
        </Typography>
        <Typography className={classes.subtitle}>Newly disabled</Typography>
        <Typography className={classes.values}>
          {count.disabled} {count.disabled === 1 ? "permission" : "permissions"}
        </Typography>

        <Box className={classes.buttonContainer}>
          <Button
            onClick={handleOk}
            size="small"
            className={classes.okButton}
            style={{
              textTransform: "none",
              backgroundColor: "#286acf",
              color: "#fff",
            }}
          >
            Ok
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
